import { createApp } from 'vue'
import 'bootstrap/dist/js/bootstrap.esm'
import { load, save } from './shared/storage'
import router from './router'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { queryClient } from './query'
import './styles.css'
import App from './App.vue'

import 'vue-select/dist/vue-select.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-icons/font/bootstrap-icons.css'

createApp(App)
  .use(router)
  .use(VueQueryPlugin, {
    queryClient,
    enableDevtoolsV6Plugin: true,
  })
  .mount('#app')

load()

window.addEventListener('focus', () => {
  window.setTimeout(() => { // load asynchronously to let blur handler on another window/tab save it first
    load()
  }, 20)
})
window.addEventListener('blur', save)
window.addEventListener('beforeunload', save)
